import { render, staticRenderFns } from "./groupSelect.vue?vue&type=template&id=58cbf111&scoped=true"
import script from "./groupSelect.vue?vue&type=script&lang=js"
export * from "./groupSelect.vue?vue&type=script&lang=js"
import style0 from "./groupSelect.vue?vue&type=style&index=0&id=58cbf111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbf111",
  null
  
)

export default component.exports